module.exports = __webpack_public_path__ + "static/media/YF46_2.07d03cae.jpg";